import { createSelector } from 'reselect';
import { selectCurrentInstance, selectInstancePublishStatus, createInstanceValueSelector } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { selectKnowledgeBaseGroup } from '../../settings/selectors/knowledgeBaseSelectors';
import { selectHasArticlePublishPermission } from '../../auth/selectors/auth';
export const selectArticleId = createInstanceValueSelector('hs_id');
export const selectArticleTitle = createInstanceValueSelector('hs_name');
export const selectArticleAIGenerated = createInstanceValueSelector('hs_is_ai_generated');
export const selectInstanceValues = createSelector([selectCurrentInstance], currentInstance => {
  if (currentInstance) {
    return currentInstance.values;
  }
  return {};
});
export const selectIsArticlePublished = createSelector([selectInstanceValues, selectInstancePublishStatus], (currentInstanceValues, publishStatus) => !!currentInstanceValues.hs_published_at && publishStatus !== 'DRAFT');
export const selectButtonTextKey = createSelector([selectIsArticlePublished, selectHasArticlePublishPermission], (isPublished, hasPermissionToPublish) => {
  if (hasPermissionToPublish) {
    // The following lang keys are defined in CEUI and are intended
    // to be shared across editors for consistency
    if (isPublished) {
      return 'header.publishButton.update.label';
    }
    return 'header.publishButton.publish.label';
  } else {
    return 'header.publishButton.notAuthorized.label';
  }
});
export const selectArticleUrl = createSelector([selectInstanceValues, selectKnowledgeBaseGroup], (instanceValues, knowledgeBase) => {
  if (instanceValues && knowledgeBase.values) {
    const {
      hs_path
    } = instanceValues;
    const {
      hs_absolute_url
    } = knowledgeBase.values;
    return `${hs_absolute_url}/${hs_path}`;
  }
  return null;
});